module.exports = __webpack_public_path__ + "images/components/estimate_banners/form_with_image/products_right_pc_db93f2bb78a127703e061dc5c9bf54de.svg";